import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { cybervolunteerApi } from "../../api/cybervolunteerApi";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Accordion from "./Accordion";
import type { SubtaskDataType } from "./PersonalPageTypes";

function PersonalPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("auth_token");

  const [subtasksData, setSubtasksData] = useState<Array<SubtaskDataType>>([]);
  const auth_name = localStorage.getItem("auth_username");
  const authUsername = auth_name ? auth_name : "";
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const is_admin = () => {
    cybervolunteerApi
      .checkAdmin()
      .then((_response) => {
        setIsAdmin(true);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        if (error.response.status === 405) {
          setIsAdmin(false);
        }
      });
  };

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true, state: { from: location } });
    }
  }, [token, navigate, location]);

  useEffect(() => {
    if (!token) return;
    is_admin();
  }, [token]);

  const get_subtask_data = useCallback(() => {
    cybervolunteerApi
      .getSubtasks()
      .then((response) => {
        const rows: Array<SubtaskDataType> = [...response.data];
        rows.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        setSubtasksData(rows);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  useEffect(() => {
    if (!token) return;
    get_subtask_data();
  }, [token, get_subtask_data]);

  function capitalize(str: string) {
    const res_string = str
      .toLowerCase()
      .split(" ")
      .map((string_part) => {
        return string_part.charAt(0).toUpperCase() + string_part.slice(1);
      })
      .join(" ");

    return res_string;
  }

  if (!token) {
    return null;
  }

  return (
    <div className="bg-white-blue main-bg">
      <Header />
      <main className="text-black">
        <section className="relative w-full container flex justify-between mx-auto gap-1-25 p-4 pt-8 md:pt-16">
          <div className="container relative">
            <div className="md:mw-56-5">
              <h2 className="f-size-2 md:f-size-3-75 font-bold lh-2-7 fw-700 mb-12">
                Личный кабинет
              </h2>
              <h3 className="f-size-1-25 md:f-size-1-5 lh-1-75 fw-700 mb-6">
                Приветствуем, {capitalize(authUsername)}!
              </h3>
            </div>
          </div>
          <div className="md:mw-56-5 w-1/2">
            <h4 className="text-right text-[1rem] leading-[1.2rem] mt-3 md:text-[1.5rem] md:leading-[1.5rem] font-bold mb-6">
              Тут ты можешь легко скачать все материалы в PDF формате, для ознакомления офлайн.
            </h4>
            <a
              className="block bg-green text-white step-button text-center justify-center"
              href="/"
            >
              Скачать
            </a>
          </div>
        </section>

        {isAdmin ? (
          <div className="rounded-md mx-auto text-black mb-3 md:w-auto mx-auto p-6">
            <div className="py-3 pl-2">
              <h2 className="text-2xl">
                Добро пожаловать, {auth_name ? auth_name : "... как ты сюда попал?"}!
              </h2>
            </div>
            <button
              onClick={(_e) => (window.location.href = "/task_list_admin")}
              className="w-full hover:bg-inherit shadow-[0_0_3px_rgba(0,0,0,0.25)] text-lg p-2 mt-3 rounded-md"
            >
              Управление задачами
            </button>
          </div>
        ) : (
          <></>
        )}

        <div className="md:w-auto mx-auto p-6">
          <div className="relative container flex justify-between mx-auto">
            <h3 className="f-size-2 font-bold lh-2-7 fw-700 mb-6">Твой поточный список задач:</h3>
          </div>
          <div className="relative bg-white p-3 container flex justify-between mx-auto mb-6">
            <div className="container">
              {subtasksData.map(function (subtask) {
                return (
                  <Accordion
                    key={subtask.subtask_id}
                    get_subtask_data={get_subtask_data}
                    subtask_id={subtask.subtask_id}
                    title={subtask.title}
                    desc={subtask.desc}
                    questions={subtask.questions}
                    status={subtask.status}
                    content={subtask.content}
                    savedAnswers={subtask.saved_answers ?? {}}
                    is_hero={subtask.is_hero ?? false}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PersonalPage;
